__turbopack_context__.v({
  "mobile-help-closer": "urgent-module-scss-module__qqCS7W__mobile-help-closer",
  "mobile-help-text-wrapper": "urgent-module-scss-module__qqCS7W__mobile-help-text-wrapper",
  "modal-max-w": "urgent-module-scss-module__qqCS7W__modal-max-w",
  "value-description": "urgent-module-scss-module__qqCS7W__value-description",
  "value-name": "urgent-module-scss-module__qqCS7W__value-name",
});
